import { useEffect, useState } from "react";
import DateInputField from "./DateInputField";
import { updateBloqueCancha } from "../services/api";

const DIAS = [
  { key: "0", label: "Lun" },
  { key: "1", label: "Mar" },
  { key: "2", label: "Mié" },
  { key: "3", label: "Jue" },
  { key: "4", label: "Vie" },
  { key: "5", label: "Sáb" },
  { key: "6", label: "Dom" },
];

const HORAS = Array.from({ length: 34 }, (_, i) => {
  const totalMin = 6 * 60 + i * 30;
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
});

const hoyStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

const franjaVacia = () => ({ inicio: "08:00", fin: "10:00" });

function BloquesManager({ canchas, bloques, onCreateBloque, onDeleteBloque }) {
  console.log("BLOQUES_DATA", bloques);
  const today = hoyStr();
  const [form, setForm] = useState({
    descripcion: "",
    cancha: canchas[0] || "",
    fecha_inicio: today,
    fecha_fin: today,
    dias_semana: ["0", "1", "2", "3", "4"],
    franjas: [franjaVacia()],
  });

  useEffect(() => {
    if (!Array.isArray(canchas) || canchas.length === 0) {
      return;
    }

    setForm((prev) => {
      if (prev.cancha && canchas.includes(prev.cancha)) {
        return prev;
      }
      return {
        ...prev,
        cancha: canchas[0],
      };
    });
  }, [canchas]);

  const handleField = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const toggleDia = (dia) => {
    setForm((prev) => {
      const current = prev.dias_semana;
      if (current.includes(dia)) {
        return { ...prev, dias_semana: current.filter((d) => d !== dia) };
      }
      return { ...prev, dias_semana: [...current, dia].sort() };
    });
  };

  const addFranja = () => {
    setForm((prev) => ({ ...prev, franjas: [...prev.franjas, franjaVacia()] }));
  };

  const removeFranja = (idx) => {
    setForm((prev) => ({ ...prev, franjas: prev.franjas.filter((_, i) => i !== idx) }));
  };

  const changeFranja = (idx, key, value) => {
    setForm((prev) => {
      const franjas = prev.franjas.map((f, i) => (i === idx ? { ...f, [key]: value } : f));
      return { ...prev, franjas };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.cancha) {
      alert("Selecciona una cancha");
      return;
    }
    if (form.dias_semana.length === 0) {
      alert("Selecciona al menos un día de la semana");
      return;
    }
    if (form.franjas.length === 0) {
      alert("Agrega al menos una franja horaria");
      return;
    }

    try {
      await onCreateBloque({
        descripcion: form.descripcion,
        cancha: form.cancha,
        fecha_inicio: form.fecha_inicio,
        fecha_fin: form.fecha_fin,
        dias_semana: form.dias_semana,
        franjas: form.franjas,
      });
      setForm((prev) => ({
        ...prev,
        descripcion: "",
        franjas: [franjaVacia()],
      }));
    } catch (_error) {
    }
  };

  const formatDias = (diasJson) => {
    try {
      const dias = JSON.parse(diasJson);
      return dias.map((d) => DIAS.find((dia) => dia.key === d)?.label || d).join(", ");
    } catch {
      return diasJson;
    }
  };

  const formatFranjas = (franjasJson) => {
    try {
      const franjas = JSON.parse(franjasJson);
      return franjas.map((f) => `${f.inicio}–${f.fin}`).join(", ");
    } catch {
      return franjasJson;
    }
  };

  return (
    <div className="panel">
  <div className="section-title">
    <h2 style={{ marginBottom: "8px" }}>Control exclusivo de escuela</h2>
  </div>

  <p
    className="hero-copy"
    style={{ marginBottom: "16px", lineHeight: "1.5", color: "#555" }}
  >
    Configura días y franjas horarias independientes para escuela. Estos bloques no se registran como reservas comerciales.
  </p>

  <form
    className="form-grid"
    onSubmit={handleSubmit}
    style={{ display: "grid", gap: "16px" }}
  >
    <label>
      <span className="visually-hidden">Descripción</span>
      <input
        name="descripcion"
        value={form.descripcion}
        onChange={handleField}
        placeholder="Descripción (ej: Escuela de tenis)"
        required
      />
    </label>

    <label>
      <span className="visually-hidden">Cancha</span>
      <select name="cancha" value={form.cancha} onChange={handleField} required>
        {canchas.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>
    </label>

    <div
      className="form-row-two"
      style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}
    >
      <label>
        <span>Desde</span>
        <DateInputField
          name="fecha_inicio"
          value={form.fecha_inicio}
          onChange={handleField}
          ariaLabel="Desde"
        />
      </label>

      <label>
        <span>Hasta</span>
        <DateInputField
          name="fecha_fin"
          value={form.fecha_fin}
          onChange={handleField}
          ariaLabel="Hasta"
        />
      </label>
    </div>

    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: "10px 14px",
        padding: "12px",
        border: "1px solid #ddd",
        borderRadius: "12px",
        background: "#f8f9fb",
      }}
    >
      <span style={{ fontWeight: "bold", minWidth: "80px" }}>Días:</span>
      {DIAS.map((d) => (
        <label
          key={d.key}
          style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
        >
          <input
            type="checkbox"
            checked={form.dias_semana.includes(d.key)}
            onChange={() => toggleDia(d.key)}
          />
          {d.label}
        </label>
      ))}
    </div>

    <div
      style={{
        display: "grid",
        gap: "12px",
        padding: "12px",
        border: "1px solid #ddd",
        borderRadius: "12px",
        background: "#f8f9fb",
      }}
    >
      <span style={{ fontWeight: "bold" }}>Franjas horarias:</span>

      {form.franjas.map((franja, idx) => (
        <div
          key={idx}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <select
            value={franja.inicio}
            onChange={(e) => changeFranja(idx, "inicio", e.target.value)}
          >
            {HORAS.map((h) => (
              <option key={h} value={h}>
                {h}
              </option>
            ))}
          </select>

          <span style={{ fontWeight: "bold", color: "#666" }}>–</span>

          <select
            value={franja.fin}
            onChange={(e) => changeFranja(idx, "fin", e.target.value)}
          >
            {HORAS.map((h) => (
              <option key={h} value={h}>
                {h}
              </option>
            ))}
          </select>

          {form.franjas.length > 1 ? (
            <button
              type="button"
              className="danger-btn-small"
              onClick={() => removeFranja(idx)}
            >
              ✕
            </button>
          ) : null}
        </div>
      ))}

      <button type="button" className="secondary-button" onClick={addFranja}>
        + Agregar franja
      </button>
    </div>

    <button type="submit">Guardar control de escuela</button>
  </form>

  <hr className="section-divider" />

  <div className="section-title">
    <h3>Controles configurados</h3>
    <span>{bloques.length} elementos</span>
  </div>

  {bloques.length === 0 ? (
    <p className="empty-copy">No hay controles de escuela configurados.</p>
  ) : (
    <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: "12px" }}>
      {bloques.map((b) => (
        <li
          key={b.id}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "12px",
            padding: "14px 16px",
            border: "1px solid #ddd",
            borderRadius: "12px",
            background: "#fff",
          }}
        >
          <div style={{ display: "grid", gap: "4px" }}>
            <strong>{b.descripcion}</strong>
            {b.descripcion === "Soccerlife" ? (
  <select
    defaultValue={b.cancha}
    onChange={async (e) => {
  const nuevaCancha = e.target.value;

  try {
    await updateBloqueCancha(b.id, nuevaCancha);
    window.location.reload();
  } catch (err) {
    alert("Error al actualizar cancha");
    console.error(err);
  }
}}
  >
    <option>Cancha Grande</option>
    <option>Cancha mitad Norte</option>
    <option>Cancha mitad Sur</option>
    <option>Cancha Tapada</option>
  </select>
) : (
  <span style={{ color: "#666", fontSize: "14px" }}>{b.cancha}</span>
)}
            <span style={{ color: "#666", fontSize: "14px" }}>
              {b.fecha_inicio} → {b.fecha_fin}
            </span>
            <span style={{ color: "#666", fontSize: "14px" }}>
              {formatDias(b.dias_semana)}
            </span>
            <span style={{ color: "#666", fontSize: "14px" }}>
              {formatFranjas(b.franjas)}
            </span>
          </div>

          <button
            type="button"
            className="danger-btn-small"
            onClick={() => onDeleteBloque(b.id, b.descripcion)}
          >
            Eliminar
          </button>
        </li>
      ))}
    </ul>
  )}
</div>
  );
}

export default BloquesManager;
